import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc5a58a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-wrap" }
const _hoisted_2 = { class: "board_table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "키워드"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "검색 횟수"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, "플랫폼별 검색 결과"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, [
      /*#__PURE__*/_createTextVNode(" 평균 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" (검색 결과) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, [
      /*#__PURE__*/_createTextVNode(" 합계 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" (검색 결과) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "모니터링")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "X(구 트위터)"),
    /*#__PURE__*/_createElementVNode("th", null, "구글"),
    /*#__PURE__*/_createElementVNode("th", null, "네이버"),
    /*#__PURE__*/_createElementVNode("th", null, "유튜브"),
    /*#__PURE__*/_createElementVNode("th", null, "인스타그램")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: 10,
    class: "spinner_table"
  }, "검색된 결과가 없습니다.")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { colspan: 10 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_PageBtn = _resolveComponent("PageBtn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (!$setup.props.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              ($setup.props.list.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.list, (value) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.keyword)
                        }, null, 8, _hoisted_6),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntSearch ? value.cntSearch.toLocaleString() : 0)
                        }, null, 8, _hoisted_7),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntTwitter ? value.cntTwitter.toLocaleString() : 0)
                        }, null, 8, _hoisted_8),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntGoogle ? value.cntGoogle.toLocaleString() : 0)
                        }, null, 8, _hoisted_9),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntNaver ? value.cntNaver.toLocaleString() : 0)
                        }, null, 8, _hoisted_10),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntYoutube ? value.cntYoutube.toLocaleString() : 0)
                        }, null, 8, _hoisted_11),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntInstagram ? value.cntInstagram.toLocaleString() : 0)
                        }, null, 8, _hoisted_12),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(
                                        value.cntResult ? (Math.round((value.cntResult / value.cntSearch) * 10) / 10).toLocaleString() : 0
                                    )
                        }, null, 8, _hoisted_13),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntResult ? value.cntResult.toLocaleString() : 0)
                        }, null, 8, _hoisted_14),
                        _createElementVNode("td", {
                          textContent: _toDisplayString(value.cntMonitoring ? value.cntMonitoring.toLocaleString() : 0)
                        }, null, 8, _hoisted_15)
                      ]))
                    }), 256))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_16, _hoisted_18))
            ], 64))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_20, [
                  _createVNode(_component_Spinner)
                ])
              ])
            ]))
      ]),
      _createVNode(_component_PageBtn, {
        currentPage: $setup.props.currentPage,
        totalLength: $setup.props.totalLength,
        perPage: $setup.props.perPage,
        onOnPaging: _cache[0] || (_cache[0] = (page) => $setup.emit('onPaging', page))
      }, null, 8, ["currentPage", "totalLength", "perPage"])
    ])
  ]))
}